import { render, staticRenderFns } from "./Procurement.vue?vue&type=template&id=ebc8a206&scoped=true&"
import script from "./Procurement.vue?vue&type=script&lang=js&"
export * from "./Procurement.vue?vue&type=script&lang=js&"
import style0 from "./Procurement.vue?vue&type=style&index=0&id=ebc8a206&prod&scoped=true&lang=css&"
import style1 from "./Procurement.vue?vue&type=style&index=1&id=ebc8a206&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc8a206",
  null
  
)

export default component.exports